import { render, staticRenderFns } from "./numRoll.vue?vue&type=template&id=6ee7f5da&scoped=true&"
import script from "./numRoll.vue?vue&type=script&lang=js&"
export * from "./numRoll.vue?vue&type=script&lang=js&"
import style0 from "./numRoll.vue?vue&type=style&index=0&id=6ee7f5da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee7f5da",
  null
  
)

export default component.exports